import { validatePresence } from 'ember-changeset-validations/validators';
import { validateUniqueness } from 'uplisting-frontend/validators/unique';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

export const AdvancedReportConfigurationValidation = {
  name: [
    validatePresence({
      presence: true,
      ignoreBlank: true,
    }),
    customMessageValidator(
      'unique_report_configuration_name',
      validateUniqueness(),
    ),
  ],
};
